import React from "react";
import { useState, useEffect, useRef } from "react";
import { Link } from 'react-router-dom';


function MenuMobile({ autenticazione,temaColori }) {

    const voci = [
        {
            titolo: "CONSULTAZIONE",
            icona: "mystery",
            link: "consultazione",
            permessi: 'read:database',
            colSfondo: "sfondoColScuro",
            colScritta: "" //se lascio vuoto eredita colore da classe colSfondo
        },
        {
            titolo: "INVENTARI / EVASIONI",
            icona: "inventory",
            link: "mag_inventario",
            permessi: 'read:logistica',
            colSfondo: "sfondoColScuro",
            colScritta: "" //se lascio vuoto eredita colore da classe colSfondo
        },
        {
            titolo: "ORDINI WEB",
            icona: "list_alt",
            link: "dbOrdini",
            permessi: 'read:logistica',
            colSfondo: "sfondoColScuro",
            colScritta: "" //se lascio vuoto eredita colore da classe colSfondo
        },
        {
            titolo: "CHECK ORDINI WEB",
            icona: "Orders",
            link: "logisticaOffline",
            permessi: 'read:logistica',
            colSfondo: "sfondoColScuro",
            colScritta: "" //se lascio vuoto eredita colore da classe colSfondo
        },
        /* {
            titolo: "TEST NO PERMESSI",
            icona: "do_not_disturb_on",
            link: "impostazioni",
            permessi: 'read:mind',
            colSfondo: "sfondoColScuro",
            colScritta: "" //se lascio vuoto eredita colore da classe colSfondo
        } */
    ]

    return (
        <div className="flex flex-wrap h-100 sfondoColScuro content-start">
            {voci.map((voce,i) => {

                const element = <div className="tc iconaTestoMenuMob">
                    <div className="material-symbols-outlined f1">{voce.icona}</div>
                    <div className="mt2">{voce.titolo}</div>
                </div>

                return(<div key={i+1} className={`w-50 riquadroMenuMobile ${voce.colSfondo} ${voce.colScritta}`}>
                    {autenticazione.permessiAPI[voce.permessi]  ? 
                        <Link to={voce.link}>{element}</Link>
                        : <div className="gray">{element}</div>}
                </div>)
            })}
        </div>
    );
}

export default MenuMobile;

